import { Spinner, SpinnerProps, extendVariants } from '@heroui/react';
import { ForwardRefExoticComponent, RefAttributes } from 'react';

export type LoadingSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface LoadingProps extends Omit<SpinnerProps, 'size'> {
  size?: LoadingSize;
}

const SpinnerComponent = extendVariants(Spinner, {
  variants: {
    size: {
      xs: {
        wrapper: 'opacity-70 w-4 h-4',
        circle1: 'border-2 border-b-current w-full h-full',
        circle2: 'border-2 border-b-current w-full h-full',
      },
      sm: {
        wrapper: 'opacity-70 w-5 h-5',
        circle1: 'border-2 border-b-current w-full h-full',
        circle2: 'border-2 border-b-current w-full h-full',
      },
      md: {
        wrapper: 'opacity-70 w-6 h-6',
        circle1: 'border-3 border-b-current w-full h-full',
        circle2: 'border-3 border-b-current w-full h-full',
      },
      lg: {
        wrapper: 'opacity-70 w-7 h-7',
        circle1: 'border-3 border-b-current w-full h-full',
        circle2: 'border-3 border-b-current w-full h-full',
      },
      xl: {
        wrapper: 'opacity-70 w-9 h-9',
        circle1: 'border-4 border-b-current w-full h-full',
        circle2: 'border-4 border-b-current w-full h-full',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
}) as ForwardRefExoticComponent<
  Omit<SpinnerProps, 'ref' | 'size'> & {
    size: LoadingSize;
  } & RefAttributes<HTMLElement | null>
>;

export function Loading({ children, size = 'md', ...props }: LoadingProps) {
  return (
    <SpinnerComponent size={size} {...props}>
      {children}
    </SpinnerComponent>
  );
}
